import { authAPI } from '../services/api.js';
import gsap from 'gsap';

export function Login(appState) {
    const container = document.createElement('div');
    container.className = 'auth-container';

    container.innerHTML = `
        <div class="auth-card">
            <div class="auth-header">
                <h1>🎮 STEM Quest</h1>
                <p>Login to Continue Your Learning Journey</p>
            </div>
            
            <form id="login-form" class="auth-form">
                <div class="form-group">
                    <label for="login-email">Email</label>
                    <input 
                        type="email" 
                        id="login-email" 
                        required 
                        placeholder="your@email.com"
                        autocomplete="email"
                    />
                </div>
                
                <div class="form-group">
                    <label for="login-password">Password</label>
                    <input 
                        type="password" 
                        id="login-password" 
                        required 
                        placeholder="••••••••"
                        autocomplete="current-password"
                        minlength="6"
                    />
                </div>
                
                <div id="login-error" class="error-message"></div>
                
                <button type="submit" class="btn btn-primary" id="login-btn">
                    <span class="btn-text">Login</span>
                    <span class="btn-loader" style="display: none;">⏳</span>
                </button>
            </form>
            
            <div class="auth-footer">
                <p>Don't have an account? <a href="#" id="show-register">Sign Up</a></p>
                <p class="demo-note">💡 Or continue with localStorage (demo mode)</p>
                <button id="demo-mode-btn" class="btn-secondary">Continue in Demo Mode</button>
            </div>
        </div>
    `;

    // Form submission
    const form = container.querySelector('#login-form');
    const errorDiv = container.querySelector('#login-error');
    const loginBtn = container.querySelector('#login-btn');
    const btnText = loginBtn.querySelector('.btn-text');
    const btnLoader = loginBtn.querySelector('.btn-loader');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const email = container.querySelector('#login-email').value;
        const password = container.querySelector('#login-password').value;

        // Clear previous errors
        errorDiv.textContent = '';

        // Show loading state
        btnText.style.display = 'none';
        btnLoader.style.display = 'inline';
        loginBtn.disabled = true;

        try {
            const response = await authAPI.login({ email, password });

            if (response.success) {
                // Store user data
                appState.user = response.data.user;
                appState.isAuthenticated = true;
                appState.useBackend = true;

                // Navigate to dashboard
                // Initialize app with authenticated state
                const { initializeApp } = await import('../app.js');
                initializeApp(appState);
            } else {
                errorDiv.textContent = response.message || 'Login failed. Please try again.';
            }
        } catch (error) {
            errorDiv.textContent = error.message || 'Server error. Please try again.';
            console.error('Login error:', error);
        } finally {
            btnText.style.display = 'inline';
            btnLoader.style.display = 'none';
            loginBtn.disabled = false;
        }
    });

    // Show register button
    container.querySelector('#show-register').addEventListener('click', async (e) => {
        e.preventDefault();
        const { navigateTo } = await import('../app.js');
        navigateTo('register', appState);
    });

    // Demo mode button
    container.querySelector('#demo-mode-btn').addEventListener('click', async () => {
        appState.useBackend = false;
        const { navigateTo } = await import('../app.js');

        // Check if user has profile in localStorage
        const savedUser = localStorage.getItem('stemQuestUser');
        if (savedUser) {
            appState.user = JSON.parse(savedUser);
            navigateTo('dashboard', appState);
        } else {
            navigateTo('setup', appState);
        }
    });

    // Entrance animation
    gsap.from(container.querySelector('.auth-card'), {
        opacity: 0,
        y: 30,
        duration: 0.6,
        ease: 'power2.out'
    });

    return container;
}
